module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAgCAYAAABgrToAAAAABGdBTUEAALGPC/xhBQAAAPZJREFUWAntmFEKwyAMhqfsEoOeoWzH2EV2qF1kx9joGQq7Rd2yIvykTc3Eig/xoSbhj8bPgqLrhuE6hekeQugOG805N3rnb2PfP0hWK89riqOCaAGkJZtarTyfIjeXM39RizZq1mzUor2mxRhpPQZatI+linqfLw7HOr2eAf1cu3mCVmDu1sY8IxhJ5PZGMJdczDOCkURuX+wkKXVy8IXYFnMi//rNE1z8g3vdSiRyqfmaJ2gFSlurjRtBLSlJZwQlMtq4EdSSknSLk2SvW4lUQGq+9reYXq2k1fE4atHmOu6jFm2u4z5pPT2paZJ+4q82DlIr7wMy+352ItBrDQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/Components/Specialties/img/cms.png
// module id = 144
// module chunks = 0